import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface AuthButtonsProps {
  isAuthenticated: boolean;
  isAdmin: boolean;
  onSignOut: () => void;
}

export const AuthButtons = ({ isAuthenticated, isAdmin, onSignOut }: AuthButtonsProps) => {
  if (!isAuthenticated || !isAdmin) return null;

  return (
    <div className="absolute top-4 right-4 space-x-4">
      <div className="flex items-center gap-4">
        <Link to="/dashboard">
          <Button variant="default">Admin Dashboard</Button>
        </Link>
        <Button onClick={onSignOut} variant="ghost">Sign Out</Button>
      </div>
    </div>
  );
};